export enum CARDS_ACTIONS {
  GET_CARDS = 'GET_CARDS',
  DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD',
}

export enum CARDS_LOADERS {
  GET_CARDS = 'GET_CARDS',
  DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD',
}
